export default __webpack_public_path__ + "static/media/import_logistic.43a03392.svg";